import React from "react";
import { LawIcon } from "./Icons";

interface BrandLogoProps {
  title?: string;
  onClick?: () => void;
  className?: string;
  hideIconOnMobile?: boolean;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  title = "Õigusabi24.ee",
  onClick,
  className = "",
  hideIconOnMobile = false,
}) => {
  const content = (
    <>
      <div className={`bg-blue-600 p-2 rounded-xl text-white shadow-lg shadow-blue-500/20 ${hideIconOnMobile ? "hidden sm:block" : ""}`}>
        <LawIcon />
      </div>
      <h1 className="text-lg font-extrabold tracking-tight text-slate-900 dark:text-white whitespace-nowrap block m-0">
        {title}
      </h1>
    </>
  );

  const baseClasses = "flex items-center gap-3 scale-95 sm:scale-100 cursor-pointer hover:opacity-80 active:scale-95 transition-all no-underline";

  if (onClick) {
    return (
      <div onClick={onClick} className={`${baseClasses} ${className}`}>
        {content}
      </div>
    );
  }

  return (
    <a href="/" className={`${baseClasses} ${className}`}>
      {content}
    </a>
  );
};
